import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {environment as env} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CartService { 
  storedCart = [];
  cartcount:number;
  crtcountAr = [];
  addOns = [];
  varientOpt = [];
  productExist:boolean;
  cutlery:string;
  foundProd:any[];
  cartCount = new EventEmitter<number>();
  cartvaliReturn:{};

  constructor(private http:HttpClient,private router:Router) { }

  addToCart(prod,id,price,finalprice,qty,image){
    var priceWithaddon = (parseFloat(finalprice) / qty ).toFixed(2);
    let prodArray = {
      "pName": prod,
      "pId": id,
      "pImage": image,
      "basePrice": price,
      "totalPrice": finalprice,
      "priceWithaddon": priceWithaddon,
      "qty": qty,
      "addons": this.addOns,
      "varients": this.varientOpt
    };

    this.productExist = false;
    this.storedCart = JSON.parse(localStorage.getItem("cartData"));
    if(this.storedCart != null && this.storedCart.length > 0){
      for(var i=0; i < this.storedCart.length; i++){
        if(this.storedCart[i].pId == prodArray.pId){
          this.productExist  = true;
        }
      }

      if(this.productExist == false){
        this.storedCart.push(prodArray);
        localStorage.setItem("cartData", JSON.stringify(this.storedCart));
        this.router.navigate(['/cart']);
      }
    }else{
      var cartArray = [];
      cartArray.push(prodArray);
      localStorage.setItem("cartData", JSON.stringify(cartArray));
      this.router.navigate(['/cart']);
    }
  }

  applyCoupon(cpcode:string, userid:number, cartarr:any[]){

    return this.http.post(env.apiurl+'apply-coupon', {
      couponcode:cpcode,
      userid:userid,
      product:cartarr
    }).pipe(rawData => {return rawData;});
  }
  
  chkCutleryAvailable(){
    if (localStorage.getItem("sjcutlery") != null && localStorage.getItem("sjcutlery") == 'yes') {
      return 'yes';
    }else if(localStorage.getItem("sjcutlery") != null && localStorage.getItem("sjcutlery") == 'no'){
      return 'no';
    }else{
      return 'yes';
    }
  }

removeLocalStorage(){
    localStorage.removeItem('cartData');
    localStorage.removeItem('sjcpncode');
    localStorage.removeItem('sjcartdcnt');
    localStorage.removeItem('sjcutlery');
    localStorage.removeItem('order_details');
  }

  cartItemCount(){
    this.crtcountAr = JSON.parse(localStorage.getItem("cartData"));
    this.cartcount = this.crtcountAr.length;
    this.cartCount.emit(this.cartcount);
  }


  checkCart(pArr:{}){
    this.storedCart = JSON.parse(localStorage.getItem("cartData"));

    if(this.storedCart){
      if(this.storedCart.length > 0){
        //console.log('Reached in main cond1');
        this.foundProd = this.storedCart.filter(elm => elm.pId == pArr['pId']);
        if(this.foundProd.length > 0){
          this.foundProd.map((fEl, index) =>{
            //Checking for Variations 
            if(fEl.varients.length > 0){
              var varrslt = this.checkCartVariations(fEl.varients, pArr['varients']);
              //console.log(varrslt);
            }

            // Checking for Adons 
            if(fEl.addons.length > 0){
              var adnrslt = this.checkCartAdons(fEl.addons, pArr['addons']);
              //console.log(adnrslt);
            }

            if(varrslt == false || adnrslt == false){
              //console.log('Add the product here');
              this.cartvaliReturn = {'result':'add',  'data':''};
            }else{
              //console.log('Update the product here');
              this.cartvaliReturn = {'result':'update', 'cid':fEl.sno, 'data':fEl};
            }
            return;
          });          
        }else{
          //console.log('Reachelse hem');
          this.cartvaliReturn  = {'result':'add', 'data':''};
        }
      }
    }else{
      //console.log('Reached in main else');
      this.cartvaliReturn  = {'result':'add', 'data':''};
      return;
    }
  }


  checkCartVariations(cVArr:any[], pVArr:any[]){
    let lcVarr = cVArr.map((el)=> el.optvalueid);
    let lpVarr = pVArr.map((el)=> el.optvalueid);

    if (lcVarr.length !== lpVarr.length) return false;
    const uniqueValues = new Set([...lcVarr, ...lpVarr]);
    
    for (const uv of uniqueValues) {
      const cCount = lcVarr.filter(e => e === uv).length;
      const pCount = lpVarr.filter(e => e === uv).length;
      if (cCount !== pCount) return false;
    }
    return true;
  }


  checkCartAdons(cVArr:any[], pVArr:any[]){
    let lcVarr = cVArr.map((el)=> el.valueid);
    let lpVarr = pVArr.map((el)=> el.valueid);

    if (lcVarr.length !== lpVarr.length) return false;
    const uniqueValues = new Set([...lcVarr, ...lpVarr]);
    
    for (const uv of uniqueValues) {
      const cCount = lcVarr.filter(e => e === uv).length;
      const pCount = lpVarr.filter(e => e === uv).length;
      if (cCount !== pCount) return false;
    }
    return true;
  }

  //Get the saved cards by useremail

  getSavedcards(email){
    //sandbox secrate key= sk_sbox_opqrbgl4cfdjcqh3pe4dmt5ilm$

    //live secrate key= sk_de3277b7-e76f-455d-9acb-1e404c9c7f16

    let headers = {
      'Authorization': 'Bearer sk_de3277b7-e76f-455d-9acb-1e404c9c7f16',
    }
    return this.http.get('https://api.checkout.com/customers/'+email, {headers}) 
  }

  //delete saved card
  
  deleteCard(id){
    let headers = {
      'Authorization': 'Bearer sk_de3277b7-e76f-455d-9acb-1e404c9c7f16',
    }
    return this.http.delete('https://api.checkout.com/instruments/'+id, {headers}) 
  }


}